import { useContext, useRef, useState } from "react";
import { Box } from "@mui/material";
import DashboardCardHeader from "./DashboardCardHeader";
import { DashboardContext } from "../context/DashboardContexProvider";
import { BaseErrorCard } from "../models/dados-indicadores.model";
import { EmptyTable } from "../../clients/components/EmptyState";
import { TrackerChartBuilder } from "../DashboardCharts/TrackerChartBuilder";

export type TrackerValue = {
  value: number;
  difference: number;
  name: string;
};

export type TrackerChartProps = {
  cardId?: string;
  title?: string;
  lastUpdate: Date;
  data: {
    expectedAngle: number;
    trackers: TrackerValue[];
    cardError: BaseErrorCard;
  };
};
export default function TrackerChart({
  cardId,
  title,
  data,
  lastUpdate,
}: TrackerChartProps) {
  const { cardsDisplayableColorProps, setCardsDisplayableColorProps } =
    useContext(DashboardContext);

  const [esperadoColor, setEsperadoColor] = useState<string>(
    cardsDisplayableColorProps.tracker.esperadoColor
  );
  const [trackersColor, setTrackersColor] = useState<string>(
    cardsDisplayableColorProps.tracker.trackersColor
  );

  const [isMouseIn, setIsMouseIn] = useState(false);

  const trackerValues = data?.trackers?.map((item) => {
    return {
      value: Number(item.value.toFixed(2)),
      name: item.name,
      title: {
        color: "transparent",
        offsetCenter: ["-40%", "80%"],
      },
      itemStyle: {
        color: trackersColor,
      },
      detail: {
        backgroundColor: "transparent",
        color: "transparent",
      },
    };
  });
  const expectedAngle = {
    value: Number(data.expectedAngle.toFixed(2)),
    name: "Esperado",
    title: {
      offsetCenter: ["0%", "-15%"],
    },
    itemStyle: {
      color: esperadoColor,
    },
    detail: {
      offsetCenter: ["0%", "5%"],
      backgroundColor: esperadoColor,
    },
  };
  const gaugeData = [...trackerValues, expectedAngle];

  const elementRef = useRef(null);
  const headerTitle = title ? "Tracker" : "";
  const timeout = 120;
  const now = new Date();
  const delay = lastUpdate ? (now.getTime() - lastUpdate.getTime()) / 1000 : 0;
  const hasDelay = delay > timeout;

  const [openModal, setopenModal] = useState<boolean>(false);

  const handleConfirmModal = () => {
    setCardsDisplayableColorProps({
      ...cardsDisplayableColorProps,
      tracker: {
        esperadoColor: esperadoColor,
        trackersColor: trackersColor,
      },
    });
    setopenModal(false);
  };

  const hasData = data.expectedAngle || data.trackers.length > 0;

  return (
    <>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
        onMouseOver={() => setIsMouseIn(true)}
        onMouseLeave={() => setIsMouseIn(false)}
      >
        <DashboardCardHeader
          cardError={data.cardError}
          hasDelay={hasDelay}
          lastUpdate={lastUpdate}
          cardId={cardId}
          elementRef={elementRef}
          isMouseIn={isMouseIn}
          title={headerTitle}
          titleFontSize={21}
          openColorsModal={openModal}
          setOpenColorsModal={setopenModal}
          colorButton
          onConfirmColorsModal={handleConfirmModal}
          colorsOptions={[
            {
              title: "Esperado",
              value: esperadoColor,
              setValue: setEsperadoColor,
            },
            {
              title: "Trackers",
              value: trackersColor,
              setValue: setTrackersColor,
            },
          ]}
        />
        {hasData ? (
          TrackerChartBuilder({
            data: gaugeData,
            elementRef: elementRef
          })
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <EmptyTable title="Nenhum dado encontrado!" />
          </Box>
        )}
      </Box>
    </>
  );
}
